import { render, staticRenderFns } from "./GoldenRules.vue?vue&type=template&id=9e2f0fe0&"
import script from "./GoldenRules.vue?vue&type=script&lang=js&"
export * from "./GoldenRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports